import React from "react";

import { Grid } from "@nel-ui/react";

import { ILayoutProps } from "../../interfaces";

const Layout: React.FC<ILayoutProps> = ({ children }) => {
  const getScreenSize = () => {
    return window.innerWidth >= 1260 ? 8 : 10;
  };

  return (
    <Grid>
      <Grid.Column
        span={{
          sm: 12,
          md: 12,
          lg: getScreenSize(),
        }}
      >
        {children}
      </Grid.Column>
    </Grid>
  );
};

export default Layout;
